// extracted by mini-css-extract-plugin
export default {"coverImg":"_1-Picture_coverImg__Vg5rF"};